import { useMutation, useQueryClient } from '@tanstack/react-query';

import { teamsKeys } from '~teacher/hook/team/teamsKeys';

import { changeTeamRole } from '../../../api/teams';


export function useChangeTeamRole() {
  const queryClient = useQueryClient();
  return useMutation(changeTeamRole, {
    onSettled: (_data, _error, { teamId }) => {
      return queryClient.invalidateQueries(teamsKeys.members(teamId));
    },
  });
}
export type UseChangeTeamRole = ReturnType<typeof useChangeTeamRole>;
